// SILKhee Color Wall — built from silkhee_colorwall_v3.html prototype
// Wired to window.SILKheeInventory + thread-colors.json
(function () {
'use strict';

const canvas = document.getElementById('color-wall-canvas');
if (!canvas) return;
const ctx = canvas.getContext('2d');
const DPR = window.devicePixelRatio || 1;

// ── CONSTANTS ──────────────────────────────────────────────────
let COLS       = 8;
const GAP      = 6;
const LH       = 52;       // label strip height (CSS px)
const CARD_RAD = 0.09;
const CH_RATIO = 0.75;
const MARGIN_X = 40;
let PER_PAGE = 56;

const UNIT_PRICE  = 7.60;
const PACK_PRICES = { 6: 36.18, 12: 68.18, 24: 126.88 };

// ── STATE ──────────────────────────────────────────────────────
let allColors = [];
let filtered  = [];
let page      = 0;
let tiles     = [];
let raf, lT = null;
let mX = -999, mY = -999;
let entranceDone = false;

// Filter state
let filterAvail = false;
let activeHues  = new Set();
let activeTemps = new Set();
let activeSats  = new Set();
let valMin = 1, valMax = 10;
let searchQ = '';
let sortMode = 'default';

// Selected tile for dropdown
let selectedTile = null;
let dropQty = 1;

// ── DOM ────────────────────────────────────────────────────────
const outer      = document.getElementById('cw-canvas-outer');
const prevBtn    = document.getElementById('cw-prev');
const nextBtn    = document.getElementById('cw-next');
const pageLabel  = document.getElementById('cw-page-label');
const countEl    = document.getElementById('cw-count');
const tooltip    = document.getElementById('cw-tooltip');
const buyDrop    = document.getElementById('cw-buy-drop');
const refinePanel = document.getElementById('cw-refine-panel');
const activeTagsEl = document.getElementById('cw-active-tags');
const applyBtn   = document.getElementById('cw-apply-filters');
const reqOverlay = document.getElementById('cw-req-overlay');
const reqModal   = document.getElementById('cw-req-modal');

// ── HELPERS ────────────────────────────────────────────────────
function h2r(h) {
  return { r: parseInt(h.slice(1,3),16), g: parseInt(h.slice(3,5),16), b: parseInt(h.slice(5,7),16) };
}
function clamp(v,a,b) { return Math.max(a,Math.min(b,v)); }
function lerp(a,b,t)  { return a+(b-a)*t; }
function eo3(t)       { return 1-Math.pow(1-t,3); }
function eo4(t)       { return 1-Math.pow(1-t,4); }

// ── CANVAS SIZING ──────────────────────────────────────────────
let W, H, cw, ch, ROWS;

function resize() {
  // Phase 4.2: responsive columns — mobile gets 4 cols, desktop stays 8
  COLS = window.innerWidth <= 768 ? 4 : 8;
  PER_PAGE = COLS * 7;
  const containerW = (outer ? outer.clientWidth : window.innerWidth) - 2 * MARGIN_X;
  cw = Math.floor((containerW - GAP * (COLS - 1)) / COLS);
  ch = Math.round(cw * CH_RATIO);

  ROWS = 7;
  W = COLS * cw + (COLS - 1) * GAP;
  H = ROWS * (ch + LH) + (ROWS - 1) * GAP;

  const dpr = window.devicePixelRatio || 1;
  canvas.style.width  = W + 'px';
  canvas.style.height = H + 'px';
  canvas.width  = W * dpr;
  canvas.height = H * dpr;
  ctx.scale(dpr, dpr);
}

// ── BUILD TILES ────────────────────────────────────────────────
function buildTiles(animate) {
  const start = page * PER_PAGE;
  const slice = filtered.slice(start, start + PER_PAGE);
  tiles = [];
  slice.forEach((col, idx) => {
    const row = Math.floor(idx / COLS);
    const col_ = idx % COLS;
    const rgb = h2r(col.hex || '#888888');
    const dist = Math.sqrt(Math.pow(col_/COLS - 0.5, 2) + Math.pow(row/ROWS - 0.5, 2));
    tiles.push({
      x: col_ * (cw + GAP),
      y: row * (ch + LH + GAP),
      w: cw, h: ch,
      col, rgb,
      hover: 0,
      selected: false,
      alpha: animate ? 0 : 1,
      enterDelay: animate ? dist * 0.9 + Math.random() * 0.15 : 0,
      enterDone: !animate,
    });
  });
  entranceDone = !animate;
}

// ── ROUNDED RECT HELPERS ───────────────────────────────────────
function rrectFull(x,y,w,h,r) {
  r = Math.max(0, r);
  ctx.beginPath();
  ctx.moveTo(x+r,y); ctx.arcTo(x+w,y,x+w,y+h,r);
  ctx.arcTo(x+w,y+h,x,y+h,r); ctx.arcTo(x,y+h,x,y,r);
  ctx.arcTo(x,y,x+w,y,r); ctx.closePath();
}
function rrectTopOnly(x,y,w,h,r) {
  r = Math.max(0, r);
  ctx.beginPath();
  ctx.moveTo(x+r,y); ctx.arcTo(x+w,y,x+w,y+h,r);
  ctx.lineTo(x+w,y+h); ctx.lineTo(x,y+h);
  ctx.arcTo(x,y,x+w,y,r); ctx.closePath();
}

// ── DRAW CARD ──────────────────────────────────────────────────
function drawCard(tile) {
  const { x, w, h, col, rgb, hover, selected, alpha } = tile;
  if (alpha < 0.005) return;
  const hv = hover;
  const y = tile.y - hv * 1; // 1px lift on hover
  const isAvail = col.avail;
  const { r, g, b } = rgb;
  const rad = Math.round(w * CARD_RAD);
  const totalH = h + LH;
  const cx = x + w / 2;
  const cy = y + h * 0.50;
  const circR = Math.max(0, w * 0.26);

  ctx.save();
  ctx.globalAlpha = alpha;

  // ── SHADOW layer 1: tight color-tinted
  ctx.save();
  ctx.shadowColor   = `rgba(${Math.round(r*0.22)},${Math.round(g*0.22)},${Math.round(b*0.22)},${lerp(0.38,0.52,hv)})`;
  ctx.shadowBlur    = lerp(16,24,hv);
  ctx.shadowOffsetX = lerp(2,4,hv);
  ctx.shadowOffsetY = lerp(10,18,hv);
  ctx.fillStyle     = 'rgba(80,80,80,0.01)';
  rrectFull(x,y,w,totalH,rad); ctx.fill();
  ctx.restore();

  // ── SHADOW layer 2: wide diffuse
  ctx.save();
  ctx.shadowColor   = `rgba(${Math.round(r*0.15)},${Math.round(g*0.15)},${Math.round(b*0.15)},${lerp(0.20,0.30,hv)})`;
  ctx.shadowBlur    = lerp(30,48,hv);
  ctx.shadowOffsetX = lerp(1,3,hv);
  ctx.shadowOffsetY = lerp(12,22,hv);
  ctx.fillStyle     = 'rgba(80,80,80,0.01)';
  rrectFull(x,y,w,totalH,rad); ctx.fill();
  ctx.restore();

  // ── COLOR AREA
  ctx.save();
  ctx.fillStyle = `rgb(${r},${g},${b})`;
  rrectTopOnly(x,y,w,h,rad); ctx.fill();
  rrectTopOnly(x,y,w,h,rad); ctx.clip();

  // Outer gradient wash
  const outerWash = ctx.createRadialGradient(x+w*0.1, y+h*0.08, 0, x+w*0.5, y+h*0.5, Math.max(0, w*1.1));
  outerWash.addColorStop(0,    'rgba(255,255,255,0.55)');
  outerWash.addColorStop(0.25, 'rgba(255,255,255,0.30)');
  outerWash.addColorStop(0.55, 'rgba(255,255,255,0.10)');
  outerWash.addColorStop(1,    'rgba(255,255,255,0.00)');
  ctx.fillStyle = outerWash; ctx.fillRect(x,y,w,h);

  // Concave halo around circle
  const haloR    = circR * 2.2;
  const haloGrad = ctx.createRadialGradient(cx,cy,circR*0.85, cx,cy,haloR);
  haloGrad.addColorStop(0,    'rgba(0,0,0,0.00)');
  haloGrad.addColorStop(0.30, 'rgba(0,0,0,0.06)');
  haloGrad.addColorStop(0.65, 'rgba(0,0,0,0.12)');
  haloGrad.addColorStop(1,    'rgba(0,0,0,0.00)');
  ctx.fillStyle = haloGrad; ctx.fillRect(x,y,w,h);

  // Circle shadow
  ctx.save();
  ctx.shadowColor   = `rgba(${Math.round(r*0.4)},${Math.round(g*0.4)},${Math.round(b*0.4)},0.35)`;
  ctx.shadowBlur    = 8;
  ctx.shadowOffsetX = 1;
  ctx.shadowOffsetY = 3;
  const circDark    = 0.82;
  ctx.fillStyle     = `rgb(${Math.round(r*circDark)},${Math.round(g*circDark)},${Math.round(b*circDark)})`;
  ctx.beginPath(); ctx.arc(cx,cy,circR,0,Math.PI*2); ctx.fill();
  ctx.restore();

  // Flat circle
  ctx.fillStyle = `rgb(${r},${g},${b})`;
  ctx.beginPath(); ctx.arc(cx,cy,circR,0,Math.PI*2); ctx.fill();

  // Unavailable overlay
  if (!isAvail) {
    ctx.fillStyle = 'rgba(215,212,208,0.65)';
    ctx.fillRect(x,y,w,h);
  }

  ctx.restore(); // end clip

  // ── LABEL STRIP — square corners
  ctx.save();
  ctx.fillStyle = 'rgba(255,255,255,0.97)';
  ctx.beginPath();
  ctx.moveTo(x,y+h); ctx.lineTo(x+w,y+h);
  ctx.lineTo(x+w,y+h+LH); ctx.lineTo(x,y+h+LH);
  ctx.closePath(); ctx.fill();

  // Hairline separator
  ctx.fillStyle = 'rgba(0,0,0,0.06)'; ctx.fillRect(x,y+h,w,0.5);

  if (!isAvail) {
    ctx.fillStyle = 'rgba(215,212,208,0.45)'; ctx.fillRect(x,y+h,w,LH);
  }

  ctx.beginPath(); ctx.rect(x,y+h,w,LH); ctx.clip();

  ctx.textBaseline = 'middle';
  ctx.textAlign    = 'left';

  // Line 1: color name — 11px, 30% down the strip
  ctx.font          = '400 11px "Courier New",Courier,monospace';
  ctx.letterSpacing = '1px';
  ctx.fillStyle     = `rgba(18,14,10,${isAvail ? 0.80 : 0.40})`;
  ctx.fillText((col.name || '').toUpperCase(), x+8, y+h+LH*0.30);

  // Line 2: color code — 10px, 68% down the strip
  ctx.font          = '400 10px "Courier New",Courier,monospace';
  ctx.letterSpacing = '1px';
  ctx.fillStyle     = `rgba(18,14,10,${isAvail ? 0.50 : 0.25})`;
  ctx.fillText(col.code || '', x+8, y+h+LH*0.68);

  ctx.restore();

  // ── SELECTED FRAME
  if (selected) {
    ctx.save();
    ctx.strokeStyle = 'rgba(255,255,255,0.92)';
    ctx.lineWidth   = 2;
    rrectFull(x+1,y+1,w-2,totalH-2,rad); ctx.stroke();
    ctx.restore();
  }

  ctx.restore(); // end global alpha
}

// ── HIT TEST ───────────────────────────────────────────────────
function getTileAt(mx, my) {
  for (const t of tiles) {
    if (mx >= t.x && mx < t.x+t.w && my >= t.y && my < t.y+t.h+LH) return t;
  }
  return null;
}

// ── TOOLTIP ────────────────────────────────────────────────────
function showTooltip(tile, ex, ey) {
  if (!tile || !tooltip) return;
  const col = tile.col;
  document.getElementById('cwt-swatch').style.background = col.hex || '#ccc';
  document.getElementById('cwt-code').textContent  = col.code || '';
  document.getElementById('cwt-name').textContent  = (col.name || '').toUpperCase();
  document.getElementById('cwt-hex').textContent   = col.hex || '';
  const tempStr = col.temp ? `   TEMP · ${col.temp}` : '';
  document.getElementById('cwt-hvst').textContent  = `HUE · ${col.hue || '—'}   VAL · ${col.val || '—'}   SAT · ${col.sat || '—'}${tempStr}`;
  const avail = document.getElementById('cwt-avail');
  if (col.avail) {
    avail.textContent    = '';
    avail.style.display  = 'none';
  } else {
    avail.textContent    = 'REQUEST';
    avail.style.display  = 'block';
  }
  let tx = ex + 16, ty = ey - 12;
  if (tx + 240 > window.innerWidth)  tx = ex - 246;
  if (ty + 130 > window.innerHeight) ty = ey - 136;
  tooltip.style.left = tx + 'px';
  tooltip.style.top  = ty + 'px';
  tooltip.classList.add('show');
}
function hideTooltip() { if (tooltip) tooltip.classList.remove('show'); }

// ── ANIMATION LOOP ─────────────────────────────────────────────
let entranceStart = null;

function startLoop() {
  if (raf) cancelAnimationFrame(raf);
  lT = null;
  entranceStart = null;

  function frame(now) {
    if (!lT) lT = now;
    const dt = Math.min((now - lT) / 1000, 0.05);
    lT = now;
    if (!entranceStart) entranceStart = now;
    const el = (now - entranceStart) / 1000;

    ctx.setTransform(DPR, 0, 0, DPR, 0, 0);
    ctx.fillStyle = '#ffffff';
    ctx.fillRect(0, 0, W, H);

    const rect = canvas.getBoundingClientRect();
    const localX = mX - rect.left;
    const localY = mY - rect.top;
    const hov = entranceDone ? getTileAt(localX, localY) : null;

    let allIn = true;
    tiles.forEach(tile => {
      const ep = clamp((el - tile.enterDelay) / 1.4, 0, 1);
      tile.alpha = eo4(ep);
      if (tile.alpha < 0.999) allIn = false;
      const isH = tile === hov && tile.col.avail;
      tile.hover = clamp(tile.hover + (isH ? 1 : -1) * dt * 5, 0, 1);
    });
    if (allIn && !entranceDone) { entranceDone = true; }

    // Shadow pass
    tiles.forEach(tile => {
      if (tile.alpha < 0.01) return;
      const rad = Math.round(tile.w * CARD_RAD);
      const { r, g, b } = tile.rgb;
      const hv = tile.hover;
      ctx.save();
      ctx.globalAlpha = tile.alpha;
      ctx.shadowColor   = `rgba(${Math.round(r*0.22)},${Math.round(g*0.22)},${Math.round(b*0.22)},${lerp(0.36,0.50,hv)})`;
      ctx.shadowBlur    = lerp(14,22,hv);
      ctx.shadowOffsetX = lerp(2,4,hv);
      ctx.shadowOffsetY = lerp(10,18,hv);
      ctx.fillStyle     = 'rgba(80,80,80,0.01)';
      rrectFull(tile.x,tile.y,tile.w,tile.h+LH,rad); ctx.fill();
      ctx.restore();
      ctx.save();
      ctx.globalAlpha = tile.alpha;
      ctx.shadowColor   = `rgba(${Math.round(r*0.15)},${Math.round(g*0.15)},${Math.round(b*0.15)},${lerp(0.18,0.28,hv)})`;
      ctx.shadowBlur    = lerp(28,45,hv);
      ctx.shadowOffsetX = lerp(1,3,hv);
      ctx.shadowOffsetY = lerp(12,22,hv);
      ctx.fillStyle     = 'rgba(80,80,80,0.01)';
      rrectFull(tile.x,tile.y,tile.w,tile.h+LH,rad); ctx.fill();
      ctx.restore();
    });

    tiles.forEach(tile => drawCard(tile));

    // Tooltip
    if (hov && localX > 0 && localY > 0) {
      showTooltip(hov, mX, mY);
    } else {
      hideTooltip();
    }

    raf = requestAnimationFrame(frame);
  }
  raf = requestAnimationFrame(frame);
}

// ── FILTER + SORT ──────────────────────────────────────────────
const HUE_ORDER = ['Neutral','Nude','Pink','Coral','Red','Orange','Yellow','Brown','Green','Teal','Blue','Purple'];
const TEMP_ORDER = { W: 0, N: 1, C: 2 };

// Hue-based warm→cool order (temperature attribute is per-color within a hue, not for sorting)
const HUE_WARM_TO_COOL = ['Red','Orange','Coral','Yellow','Brown','Pink','Nude','Neutral','Purple','Green','Teal','Blue'];

function normSat(s) {
  // Fix known typo in Shopify metafield data
  return s === 'Vivd' ? 'Vivid' : s;
}

function applyFilters() {
  let result = allColors.slice();

  if (filterAvail)      result = result.filter(c => c.avail);
  if (searchQ)          result = result.filter(c =>
    (c.name||'').toLowerCase().includes(searchQ) ||
    (c.code||'').toLowerCase().includes(searchQ)
  );
  if (activeHues.size)  result = result.filter(c => activeHues.has(c.hue));
  if (activeTemps.size) result = result.filter(c => activeTemps.has(c.temp));
  if (activeSats.size)  result = result.filter(c => activeSats.has(normSat(c.sat)));
  result = result.filter(c => (c.val||5) >= valMin && (c.val||5) <= valMax);

  // Sort
  if (sortMode === 'family') {
    result.sort((a,b) => (HUE_ORDER.indexOf(a.hue) - HUE_ORDER.indexOf(b.hue)) || (a.val - b.val));
  } else if (sortMode === 'warm-cool') {
    result.sort((a, b) => {
      const ai = HUE_WARM_TO_COOL.indexOf(a.hue);
      const bi = HUE_WARM_TO_COOL.indexOf(b.hue);
      if (ai !== bi) return (ai === -1 ? 999 : ai) - (bi === -1 ? 999 : bi);
      return (a.val || 0) - (b.val || 0);
    });
  } else if (sortMode === 'cool-warm') {
    result.sort((a, b) => {
      const ai = HUE_WARM_TO_COOL.indexOf(a.hue);
      const bi = HUE_WARM_TO_COOL.indexOf(b.hue);
      if (ai !== bi) return (bi === -1 ? 999 : bi) - (ai === -1 ? 999 : ai);
      return (a.val || 0) - (b.val || 0);
    });
  } else if (sortMode === 'light-dark') {
    result.sort((a,b) => a.val - b.val);
  } else if (sortMode === 'dark-light') {
    result.sort((a,b) => b.val - a.val);
  } else {
    result.sort((a,b) => parseInt(a.code||0,10) - parseInt(b.code||0,10));
  }

  filtered = result;
  page = 0;
  if (countEl) {
    const total = allColors.length;
    countEl.textContent = filtered.length < total
      ? `${filtered.length} OF ${total} COLORS`
      : `${total} COLORS`;
  }
  if (applyBtn) applyBtn.textContent = `APPLY (${filtered.length} colors)`;
  updateActiveTags();
  refresh(true);
}

function refresh(animate) {
  closeDrop();
  resize();
  buildTiles(!!animate);
  updatePagination();
  startLoop();
}

function updatePagination() {
  const total = Math.max(1, Math.ceil(filtered.length / PER_PAGE));
  if (prevBtn)   prevBtn.disabled   = page === 0;
  if (nextBtn)   nextBtn.disabled   = page >= total - 1;
  if (pageLabel) pageLabel.textContent = `${page+1} / ${total}`;
}

// ── ACTIVE TAGS ────────────────────────────────────────────────
function updateActiveTags() {
  if (!activeTagsEl) return;
  activeTagsEl.innerHTML = '';
  const add = (label, clear) => {
    const t = document.createElement('button');
    t.className = 'cw-active-tag';
    t.textContent = label + ' ×';
    t.addEventListener('click', clear);
    activeTagsEl.appendChild(t);
  };
  if (filterAvail) add('Available', () => { filterAvail = false; document.getElementById('cw-avail-only').checked = false; applyFilters(); });
  activeHues.forEach(h  => add(h,  () => { activeHues.delete(h);  refreshPills(); applyFilters(); }));
  activeTemps.forEach(t => add(t==='W'?'Warm':t==='N'?'Neutral':'Cool', () => { activeTemps.delete(t); refreshPills(); applyFilters(); }));
  activeSats.forEach(s  => add(s,  () => { activeSats.delete(s);  refreshPills(); applyFilters(); }));
  if (valMin > 1 || valMax < 10) add(`Val ${valMin}–${valMax}`, () => { valMin=1; valMax=10; syncSliders(); applyFilters(); });
  if (searchQ) add(`"${searchQ}"`, () => { searchQ=''; const si=document.getElementById('cw-search'); if(si) si.value=''; applyFilters(); });
}

function refreshPills() {
  document.querySelectorAll('[data-hue]').forEach(p  => p.classList.toggle('active', activeHues.has(p.dataset.hue)));
  document.querySelectorAll('[data-temp]').forEach(p => p.classList.toggle('active', activeTemps.has(p.dataset.temp)));
  document.querySelectorAll('[data-sat]').forEach(p  => p.classList.toggle('active', activeSats.has(p.dataset.sat)));
}

function syncSliders() {
  const mn = document.getElementById('cw-val-min');
  const mx = document.getElementById('cw-val-max');
  if (mn) mn.value = valMin;
  if (mx) mx.value = valMax;
  const rd = document.getElementById('cw-val-readout');
  if (rd) rd.textContent = `${valMin} – ${valMax}`;
  updateSliderFill();
}

// ── BUY DROPDOWN ───────────────────────────────────────────────
function openDrop(tile) {
  selectedTile = tile;
  dropQty = 1;
  const col = tile.col;
  const qty = col.qty || 0;

  // Qty label
  document.getElementById('cw-qty-val').textContent = 1;
  document.getElementById('cw-price-1pc').textContent = `$${UNIT_PRICE.toFixed(2)}`;

  // Dynamic palette button label
  const palBtn = document.getElementById('cw-buy-palette-btn');
  if (palBtn && typeof window.silkheeGetPaletteState === 'function') {
    const ps = window.silkheeGetPaletteState();
    palBtn.textContent = ps.colors.length > 0 ? '+ ADD TO PALETTE' : '+ BUILD A PALETTE';
  }

  // Pack availability
  [6, 12, 24].forEach(n => {
    const btn  = document.getElementById(`cw-add-${n}pk`);
    const stEl = document.getElementById(`cw-stock-${n}pk`);
    const row  = document.getElementById(`cw-buy-row-${n}pk`);
    const ok   = qty >= n;
    btn.disabled = !ok;
    row.classList.toggle('cw-buy-disabled', !ok);
    if (!ok && qty > 0) {
      stEl.textContent = `ONLY ${qty} IN STOCK`;
      stEl.style.display = 'block';
    } else {
      stEl.style.display = 'none';
    }
  });

  // Position: below card, flip if needed
  const rect = canvas.getBoundingClientRect();
  const tx = rect.left + tile.x;
  const ty = rect.top + tile.y + tile.h + LH + 4;
  buyDrop.style.display = 'block';
  const dW = buyDrop.offsetWidth;
  const dH = buyDrop.offsetHeight;
  let left = tx;
  if (left + dW > window.innerWidth - 8) left = window.innerWidth - dW - 8;
  let top = ty;
  if (top + dH > window.innerHeight - 8) top = rect.top + tile.y - dH - 4;
  buyDrop.style.left = left + 'px';
  buyDrop.style.top  = top + 'px';

  // Close dropdown when user scrolls away
  const lastScrollY = window.scrollY;
  const onScroll = () => {
    if (Math.abs(window.scrollY - lastScrollY) > 10) {
      closeDrop();
      window.removeEventListener('scroll', onScroll);
    }
  };
  window.removeEventListener('scroll', openDrop._scrollHandler || (() => {}));
  window.addEventListener('scroll', onScroll, { passive: true });
  openDrop._scrollHandler = onScroll;
}

function closeDrop() {
  if (buyDrop) buyDrop.style.display = 'none';
  if (selectedTile) { selectedTile.selected = false; selectedTile = null; }
}

async function addToCart(variantId, qty, props) {
  const body = { items: [{ id: variantId, quantity: qty || 1 }] };
  if (props) body.items[0].properties = props;
  const res = await fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(body),
  });
  if (!res.ok) throw new Error(await res.text());
  if (typeof window.refreshCart === 'function') window.refreshCart();
  if (typeof window.openCart === 'function') window.openCart();
}

// Fetch variant ID for a thread color by handle (cached)
const variantCache = {};
async function getVariantId(handle, packSize) {
  const key = `${handle}:${packSize}`;
  if (variantCache[key]) return variantCache[key];
  try {
    const res      = await fetch(`/products/${handle}.json`);
    const data     = await res.json();
    const variants = data.product?.variants || [];
    const target   = packSize === 1
      ? variants.find(v => !v.sku?.includes('*'))
      : variants.find(v => v.sku?.includes(`*${packSize}`));
    const id = target?.id || null;
    if (id) variantCache[key] = id;
    return id;
  } catch(e) {
    console.error('[CW] getVariantId error:', e);
    return null;
  }
}

// Prefetch variant IDs for available colors after page loads (background, fire-and-forget)
function prefetchVariants() {
  allColors.filter(c => c.avail).slice(0, 60).forEach(col => {
    [1, 6, 12, 24].forEach(qty => {
      if (col.qty >= qty) getVariantId(col.handle, qty);
    });
  });
}

// ── REQUEST MODAL ──────────────────────────────────────────────
function openReqModal(col) {
  if (!reqModal) return;
  document.getElementById('cw-req-swatch').style.background = col.hex || '#ccc';
  document.getElementById('cw-req-name').textContent = (col.name || '').toUpperCase();
  document.getElementById('cw-req-meta').textContent  = `${col.hex || ''}  ·  ${col.code || ''}`;
  const tagParts = [
    `HUE: ${col.hue || '—'}`,
    `SAT: ${col.sat || '—'}`,
    `VAL: ${col.val ?? '—'}/10`,
  ];
  if (col.temp) tagParts.push(`TEMP: ${col.temp}`);
  document.getElementById('cw-req-tags').textContent = tagParts.join('  ·  ');
  document.getElementById('cw-req-code-h').value = col.code || '';
  document.getElementById('cw-req-name-h').value = col.name || '';
  document.getElementById('cw-req-qty-h').value = '1';
  document.getElementById('cw-req-success').style.display = 'none';
  // Reset qty opts
  document.querySelectorAll('.cw-req-qty-opt').forEach((b,i) => b.classList.toggle('active', i===0));
  reqOverlay.style.display = 'block';
  reqModal.style.display   = 'block';
  reqOverlay.setAttribute('aria-hidden','false');
  reqModal.setAttribute('aria-hidden','false');
  const pag = document.querySelector('.cw-pagination');
  if (pag) pag.style.display = 'none';
}

function closeReqModal() {
  if (!reqModal) return;
  reqOverlay.style.display = 'none';
  reqModal.style.display   = 'none';
  const pag = document.querySelector('.cw-pagination');
  if (pag) pag.style.display = '';
}

// ── CANVAS EVENTS ──────────────────────────────────────────────
canvas.addEventListener('mousemove', e => { mX = e.clientX; mY = e.clientY; });
canvas.addEventListener('mouseleave', () => { mX = -999; mY = -999; hideTooltip(); });

window.addEventListener('silkhee:palette-add-mode', () => {
  canvas.dataset.paletteAddMode = '1';
  canvas.style.cursor = 'crosshair';
  closeDrop();
});
document.addEventListener('keydown', e => {
  if (e.key === 'Escape' && canvas.dataset.paletteAddMode === '1') {
    delete canvas.dataset.paletteAddMode;
    canvas.style.cursor = '';
  }
});

canvas.addEventListener('click', e => {
  // Palette add-mode hijack — must run first, before entranceDone and all other logic
  if (canvas.dataset.paletteAddMode === '1') {
    delete canvas.dataset.paletteAddMode;
    canvas.style.cursor = '';
    e.stopImmediatePropagation();
    const rect = canvas.getBoundingClientRect();
    const tile = getTileAt(e.clientX - rect.left, e.clientY - rect.top);
    if (tile && tile.col.avail && typeof window.silkheeAddToPalette === 'function') {
      window.silkheeAddToPalette(tile.col);
    }
    return;
  }

  if (!entranceDone) return;
  const rect  = canvas.getBoundingClientRect();
  const tile  = getTileAt(e.clientX - rect.left, e.clientY - rect.top);

  if (!tile) { closeDrop(); return; }

  if (!tile.col.avail) {
    closeDrop();
    openReqModal(tile.col);
    return;
  }

  // Toggle selection + dropdown
  if (selectedTile === tile) { closeDrop(); return; }
  if (selectedTile) selectedTile.selected = false;
  tile.selected = true;
  openDrop(tile);
});

// Close drop on outside click
document.addEventListener('click', e => {
  if (buyDrop && !buyDrop.contains(e.target) && !canvas.contains(e.target)) {
    closeDrop();
  }
});

// ── CONTROL BINDINGS ───────────────────────────────────────────
// Pagination
if (prevBtn) prevBtn.addEventListener('click', () => {
  if (page > 0) { page--; refresh(false); }
});
if (nextBtn) nextBtn.addEventListener('click', () => {
  const total = Math.ceil(filtered.length / PER_PAGE);
  if (page < total - 1) { page++; refresh(false); }
});

// Search
const searchInp = document.getElementById('cw-search');
let searchTimer;
if (searchInp) searchInp.addEventListener('input', () => {
  clearTimeout(searchTimer);
  searchTimer = setTimeout(() => { searchQ = searchInp.value.trim().toLowerCase(); applyFilters(); }, 200);
});

// Refine toggle
const refineToggle = document.getElementById('cw-refine-toggle');
if (refineToggle && refinePanel) {
  refineToggle.addEventListener('click', () => {
    const open = refinePanel.style.display !== 'none';
    refinePanel.style.display = open ? 'none' : 'block';
    if (sortPanel) sortPanel.style.display = 'none';
    refineToggle.setAttribute('aria-expanded', !open);
    refineToggle.textContent = open ? 'REFINE +' : 'REFINE −';
  });
}

// Sort options — always-visible row, no panel toggle needed
document.querySelectorAll('.cw-sort-opt').forEach(btn => {
  btn.addEventListener('click', () => {
    sortMode = btn.dataset.sort;
    document.querySelectorAll('.cw-sort-opt').forEach(b => b.classList.toggle('active', b === btn));
    applyFilters();
  });
});

// Apply button — closes refine panel
if (applyBtn) applyBtn.addEventListener('click', () => {
  if (refinePanel) {
    refinePanel.style.display = 'none';
    const refineToggle = document.getElementById('cw-refine-toggle');
    if (refineToggle) { refineToggle.setAttribute('aria-expanded', 'false'); refineToggle.textContent = 'REFINE +'; }
  }
});

// Availability
const availCb = document.getElementById('cw-avail-only');
if (availCb) availCb.addEventListener('change', () => { filterAvail = availCb.checked; applyFilters(); });

// Hue pills
document.querySelectorAll('[data-hue]').forEach(p => {
  p.addEventListener('click', () => {
    p.classList.toggle('active');
    if (p.classList.contains('active')) activeHues.add(p.dataset.hue);
    else activeHues.delete(p.dataset.hue);
    applyFilters();
  });
});

// Temp pills
document.querySelectorAll('[data-temp]').forEach(p => {
  p.addEventListener('click', () => {
    p.classList.toggle('active');
    if (p.classList.contains('active')) activeTemps.add(p.dataset.temp);
    else activeTemps.delete(p.dataset.temp);
    applyFilters();
  });
});

// Sat pills
document.querySelectorAll('[data-sat]').forEach(p => {
  p.addEventListener('click', () => {
    p.classList.toggle('active');
    if (p.classList.contains('active')) activeSats.add(p.dataset.sat);
    else activeSats.delete(p.dataset.sat);
    applyFilters();
  });
});

// Value sliders
const valMinEl = document.getElementById('cw-val-min');
const valMaxEl = document.getElementById('cw-val-max');
function updateSliderFill() {
  const min = parseInt(valMinEl.value);
  const max = parseInt(valMaxEl.value);
  const fill = document.getElementById('cw-track-fill');
  if (!fill) return;
  const pMin = ((min - 1) / 9) * 100;
  const pMax = ((max - 1) / 9) * 100;
  fill.style.left = pMin + '%';
  fill.style.width = (pMax - pMin) + '%';
}
function onValSlider() {
  valMin = parseInt(valMinEl.value, 10);
  valMax = parseInt(valMaxEl.value, 10);
  if (valMin > valMax) { const tmp=valMin; valMin=valMax; valMax=tmp; }
  updateSliderFill();
  syncSliders();
  applyFilters();
}
if (valMinEl) valMinEl.addEventListener('input', onValSlider);
if (valMaxEl) valMaxEl.addEventListener('input', onValSlider);

// Reset
const resetBtn = document.getElementById('cw-reset-all');
if (resetBtn) resetBtn.addEventListener('click', () => {
  filterAvail = false; searchQ = '';
  activeHues.clear(); activeTemps.clear(); activeSats.clear();
  valMin = 1; valMax = 10; sortMode = 'default';
  if (availCb) availCb.checked = false;
  if (searchInp) searchInp.value = '';
  document.querySelectorAll('.cw-pill').forEach(p => p.classList.remove('active'));
  document.querySelectorAll('.cw-sort-opt').forEach(b => b.classList.toggle('active', b.dataset.sort==='default'));
  syncSliders();
  applyFilters();
});

// ── QTY CONTROLS ───────────────────────────────────────────────
const qtyValEl = document.getElementById('cw-qty-val');
document.getElementById('cw-qty-minus')?.addEventListener('click', () => {
  if (dropQty > 1) { dropQty--; qtyValEl.textContent = dropQty; document.getElementById('cw-price-1pc').textContent = `$${(dropQty*UNIT_PRICE).toFixed(2)}`; }
});
document.getElementById('cw-qty-plus')?.addEventListener('click', () => {
  if (dropQty < 99) { dropQty++; qtyValEl.textContent = dropQty; document.getElementById('cw-price-1pc').textContent = `$${(dropQty*UNIT_PRICE).toFixed(2)}`; }
});

// ── ADD TO CART BUTTONS ────────────────────────────────────────
document.getElementById('cw-add-1pc')?.addEventListener('click', async () => {
  if (!selectedTile) return;
  const col = selectedTile.col;
  try {
    const vid = await getVariantId(col.handle, 1);
    if (!vid) throw new Error('No variant');
    await addToCart(vid, dropQty);
    closeDrop();
  } catch(e) { console.error('[CW] Add 1PC failed:', e); }
});

[6, 12, 24].forEach(n => {
  document.getElementById(`cw-add-${n}pk`)?.addEventListener('click', async () => {
    if (!selectedTile) return;
    const col = selectedTile.col;
    try {
      const vid = await getVariantId(col.handle, n);
      if (!vid) throw new Error('No variant');
      await addToCart(vid, 1);
      closeDrop();
    } catch(e) { console.error(`[CW] Add ${n}PK failed:`, e); }
  });
});

// BUILD A PALETTE
document.getElementById('cw-buy-palette-btn')?.addEventListener('click', () => {
  if (!selectedTile) return;
  if (typeof window.silkheeAddToPalette === 'function') {
    window.silkheeAddToPalette(selectedTile.col);
  }
  closeDrop();
});

// ── REQUEST MODAL BINDINGS ─────────────────────────────────────
document.getElementById('cw-req-close')?.addEventListener('click', closeReqModal);
reqOverlay?.addEventListener('click', closeReqModal);

document.querySelectorAll('.cw-req-qty-opt').forEach(btn => {
  btn.addEventListener('click', () => {
    document.querySelectorAll('.cw-req-qty-opt').forEach(b => b.classList.remove('active'));
    btn.classList.add('active');
    document.getElementById('cw-req-qty-h').value = btn.dataset.qty;
  });
});

document.getElementById('cw-req-form')?.addEventListener('submit', async e => {
  e.preventDefault();
  const form    = e.target;
  const email   = document.getElementById('cw-req-email').value;
  const code    = document.getElementById('cw-req-code-h').value;
  const name    = document.getElementById('cw-req-name-h').value;
  const qty     = document.getElementById('cw-req-qty-h').value;
  try {
    await fetch('https://formspree.io/f/mnjkeapo', {
      method: 'POST',
      headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' },
      body: JSON.stringify({ email, color_code: code, color_name: name, quantity: qty, source: 'wall-request' }),
    });
  } catch(_) {}
  const successEl = document.getElementById('cw-req-success');
  if (successEl) { successEl.style.display = 'block'; }
  setTimeout(closeReqModal, 2000);
});

// ── LOAD DATA ──────────────────────────────────────────────────
async function loadColors() {
  const meta = document.querySelector('meta[name="thread-colors-url"]');
  const url  = meta?.getAttribute('content') || window.THREAD_COLORS_URL;
  if (!url) { console.error('[CW] No thread-colors-url'); return; }

  const raw = await fetch(url).then(r => r.json());

  // Normalize color data first (val scale), all cards start unavailable
  const colors = raw
    .filter(c => parseInt(c.code||0,10) < 5590)
    .map(c => {
      const rawVal  = c.val || 50;
      const normVal = rawVal > 10 ? Math.max(1, Math.min(10, Math.round(rawVal / 10))) : (rawVal || 5);
      return { ...c, val: normVal, qty: 0, avail: false };
    });

  // Fetch live inventory from Vercel proxy
  const codes = colors.map(c => c.code).join(',');
  let inv = {};
  try {
    const res = await fetch(
      `https://silkhee-inventory-proxy.vercel.app/api/inventory?codes=${codes}`
    );
    if (res.ok) {
      inv = await res.json();
    } else {
      console.warn('[CW] Inventory fetch failed — status', res.status, '— all cards set to unavailable');
    }
  } catch (e) {
    console.warn('[CW] Inventory fetch error — all cards set to unavailable:', e);
  }

  // Apply inventory quantities + metafields (proxy now returns objects)
  allColors = colors.map(c => {
    const invEntry = inv[c.code];                          // undefined if Vercel didn't return this code
    const entry    = invEntry ?? { qty: 0 };
    const qty      = typeof entry === 'number' ? entry : (entry.qty ?? 0);
    const avail    = qty >= 1;
    const fromMetafields = invEntry !== undefined;          // true only when Vercel actually returned data
    return {
      ...c,
      qty,
      avail,
      hex:  entry.hex  || c.hex,                           // hex: use Vercel if present, else JSON
      hue:  fromMetafields ? (entry.hue  || '') : c.hue,   // ALWAYS Vercel if available, never fall back to JSON
      sat:  fromMetafields ? normSat(entry.sat || '') : c.sat,
      val:  fromMetafields ? (entry.val  ?? null) : c.val,
      temp: fromMetafields ? (entry.temp || '') : c.temp,
      // family: use Shopify metafield if available, otherwise fall back to thread-colors.json
      family: (fromMetafields && entry.family) ? entry.family : c.family,
    };
  });

  // Log first 10 for verification
  console.log('[CW] First 10 inventory results:',
    allColors.slice(0, 10).map(c => ({ code: c.code, qty: c.qty, avail: c.avail, temp: c.temp }))
  );

  applyFilters();
  setTimeout(prefetchVariants, 2000); // warm the cache in background after load
}

// ── RESIZE ─────────────────────────────────────────────────────
let resizeTimer;
let lastViewportW = 0;
window.addEventListener('resize', () => {
  const vw = document.documentElement.clientWidth;
  if (vw === lastViewportW) return;
  lastViewportW = vw;
  clearTimeout(resizeTimer);
  resizeTimer = setTimeout(() => {
    resize();
    buildTiles(false);
    startLoop();
  }, 150);
});

// Fix for pages where outer.clientWidth was 0 when resize() first ran.
// If canvas is stuck at the browser default (300×150), re-trigger the
// render chain once the outer container's real size is measurable.
// On all pages where the canvas already initialized correctly, the
// guard condition is false and this is a no-op.
if (outer && typeof ResizeObserver !== 'undefined') {
  const fixStuckCanvas = new ResizeObserver(() => {
    if (canvas.width === 300 && canvas.height === 150 && outer.clientWidth > 0) {
      refresh(false);
      fixStuckCanvas.disconnect();
    }
  });
  fixStuckCanvas.observe(outer);
}

loadColors();

})();
